var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.13316 14.2826C8.56529 14.2826 7.94667 14.028 7.45754 13.5389C6.63242 12.7129 6.46354 11.5535 7.06554 10.8413C7.22129 10.6575 7.49867 10.6339 7.68154 10.7896C7.86617 10.9454 7.88979 11.2219 7.73404 11.4065C7.43829 11.7565 7.59229 12.4355 8.07704 12.9203C8.58104 13.4251 9.29154 13.566 9.62492 13.2309C9.92766 12.929 9.82791 12.4408 9.31517 11.6961L9.26004 11.6156C8.44104 10.4265 8.37104 9.53489 9.00716 8.89964C9.35016 8.55664 9.85679 8.40701 10.3975 8.48226C10.8998 8.55489 11.395 8.81214 11.7923 9.21026C12.6174 10.0354 12.7863 11.1956 12.1843 11.907C12.0285 12.0925 11.7538 12.1153 11.5674 11.9586C11.3828 11.8029 11.36 11.5264 11.5158 11.3418C11.8115 10.9918 11.6575 10.3128 11.1728 9.82889C10.6688 9.32576 9.95917 9.18401 9.62492 9.51826C9.32217 9.82014 9.42191 10.3084 9.93554 11.0548L9.99067 11.1353C10.8088 12.3218 10.8788 13.2134 10.2427 13.8495C9.95129 14.1418 9.55666 14.2826 9.13316 14.2826Z",
    fill: "#02A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.43674 14C7.32474 14 7.21274 13.9571 7.12699 13.8723C6.95637 13.7016 6.95637 13.4243 7.12699 13.2536L11.502 8.87864C11.6726 8.70802 11.95 8.70802 12.1206 8.87864C12.2912 9.04927 12.2912 9.32664 12.1206 9.49726L7.74562 13.8723C7.66074 13.9571 7.54874 14 7.43674 14Z",
    fill: "#02A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.31247 21C8.20047 21 8.08847 20.9571 8.00272 20.8722L0.127725 12.9972C-0.0429004 12.8266 -0.0429004 12.5493 0.127725 12.3786L12.3777 0.128625C12.46 0.046375 12.5711 0 12.6875 0H20.5625C20.804 0 21 0.196 21 0.4375V8.3125C21 8.42887 20.9536 8.54 20.8722 8.62225L8.62222 20.8722C8.53647 20.9571 8.42447 21 8.31247 21ZM1.0561 12.6875L8.31247 19.9439L20.125 8.13138V0.875H12.8686L1.0561 12.6875Z",
    fill: "#02A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.1875 7C14.9809 7 14 6.01825 14 4.8125C14 3.60675 14.9809 2.625 16.1875 2.625C17.3941 2.625 18.375 3.60675 18.375 4.8125C18.375 6.01825 17.3941 7 16.1875 7ZM16.1875 3.5C15.4639 3.5 14.875 4.08887 14.875 4.8125C14.875 5.53612 15.4639 6.125 16.1875 6.125C16.9111 6.125 17.5 5.53612 17.5 4.8125C17.5 4.08887 16.9111 3.5 16.1875 3.5Z",
    fill: "#02A0FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.2978e64ad18d4518978fa299a03158f7.svg";
export { ForwardRef as ReactComponent };